import * as React from 'react';
import './rvChart.css';

interface ChartFootnoteRow {
    label: string;
    text: React.ReactNode;
}

interface ChartFootnoteProps {
    rows: ChartFootnoteRow[];
}

// The small print under a chart ("$x total estimated fees, n matters without estimates"), as a tidy label / text list instead of
// one centred paragraph with line breaks. Display only; the numbers are the chart's own.
export const ChartFootnote: React.FC<ChartFootnoteProps> = ({ rows }) => (
    <dl className="rv-chart-footnote">
        {rows.map((row) => (
            <div key={row.label} className="rv-chart-footnote-row">
                <dt>{row.label}</dt>
                <dd>{row.text}</dd>
            </div>
        ))}
    </dl>
);
